// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__knmHd","productName":"Table_productName__1JFG8"};